import { useEffect } from 'react';

function useConstructor(func: Function) {
  useEffect(() => {
    func();
  }, []);
}

export default useConstructor;
